import React, { useContext, useEffect, useState } from "react";
import AntdTable from "../../../antd/Table/Table";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans, { isRTL } from "../../../../utils";
import { Tag } from "antd";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import { PriorityColor } from "../../../../constants";

const ServiceRequestReportTable = ({
  startDate,
  endDate,
  currentPage,
  setCurrentPage,
  data,
  isLoading,
}) => {
  //   const { setFileName, setExportIds, setStartDateE, setEndDateE } =
  //     useContext(exportContext);
  const {
    setSort: SetSortFilter,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
    };
  }, [SetSortFilter]);

  const columns = [
    {
      title: trans("Request Code"),
      dataIndex: "serviceRequestCode",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      render: (serviceRequestCode) => (
        <span className={"table-element-name ps-0"}>{serviceRequestCode}</span>
      ),
      sorter: true,
    },

    {
      title: trans("Task ID"),
      dataIndex: "taskCode",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Service Type"),
      dataIndex: "serviceType",
      width: 150,
      sorter: true,
      render: (serviceType) => <span>{trans(serviceType)}</span>,
    },
    {
      title: trans("Requested By"),
      dataIndex: "requestedBy",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Assignee To"),
      dataIndex: "assignedStaff",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Preferred Time"),
      dataIndex: "preferredTime",
      width: 150,
      render: (_, record) => (
        <span>
          {record?.preferredTime
            ? formatDateString(record?.preferredTime)
            : "- - - - -"}
        </span>
      ),
      sorter: true,
    },
    {
      title: trans("Created At"),
      dataIndex: "createdAt",
      width: 150,
      render: (_, record) => (
        <span>
          {record?._metadata?.createdAt
            ? formatDateString(record?._metadata?.createdAt)
            : "- - - - -"}
        </span>
      ),
      sorter: true,
    },

    {
      title: trans("Start Time"),
      dataIndex: "actualStartTime",
      width: 150,
      sorter: true,
      render: (_, record) => (
        <span>
          {record?.actualStartTime
            ? formatDateString(record?.actualStartTime)
            : "- - - - -"}
        </span>
      ),
    },
    {
      title: trans("End Time"),
      dataIndex: "actualEndTime",
      width: 150,
      sorter: true,
      render: (_, record) => (
        <span>
          {record?.actualEndTime
            ? formatDateString(record?.actualEndTime)
            : "- - - - -"}
        </span>
      ),
    },
    {
      title: trans("Taken Time"),
      dataIndex: "actualDuration",
      width: 150,
      sorter: true,
      render: (_, record) => (
        <span>
          {record?.actualDuration ? record?.actualDuration : "- - - - -"}
        </span>
      ),
    },

    {
      title: trans("Priority"),
      dataIndex: "taskPriority",
      width: 150,
      render: (_, record) => (
        <Tag
          color={
            PriorityColor[record?._metadata?.taskPriority] ||
            PriorityColor.default
          }
          className="text-capitalize"
        >
          {trans(record?._metadata?.taskPriority)}
        </Tag>
      ),
    },
  ];

  //   useEffect(() => {
  //     if (data) {
  //       setFileName("Summary Report");
  //       setExportIds(selectedids);
  //       setStartDateE(startDate);
  //       setEndDateE(endDate);
  //     }
  //   }, [data, startDate, endDate, selectedids]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      SetSortFilter({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      SetSortFilter({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <AntdTable
        columns={columns}
        dataSource={data?.rows || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={data?.pagination?.totalPages || 0}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={350}
      />
    </div>
  );
};

export default ServiceRequestReportTable;
